import { notification, Switch } from "antd";
import { useState } from "react";

import { TableParams } from "../";
import { useAppDispatch } from "../../../../app/hooks";
import { getPaginatedProvidersAsync } from "../../../../features/driver/driverSlice";
import { approveProvider } from "../../../../services/adminProviderApi";

export interface Props {
  providerId: number;
  disabled: boolean;
  status: string;
  tableParams: TableParams;
  search: string;
}

const DriverStatusSwitch = ({
  providerId,
  disabled,
  status,
  tableParams,
  search,
}: Props) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();

  const onChange = async (approve: boolean) => {
    setLoading(true);
    let filters: string = "";

    if (search) {
      filters = JSON.stringify({
        first_name: search,
        last_name: search,
      });
    }

    try {
      await approveProvider(providerId).then(() =>
        dispatch(
          getPaginatedProvidersAsync({
            page: tableParams.pagination?.current || 1,
            take: tableParams.pagination?.pageSize || 10,
            filters: filters,
          }),
        ),
      );

      notification.success({
        message: `Operación exitosa`,
        description: `El conductor se ${
          approve ? "aprobó" : "desaprobó"
        } correctamente`,
        placement: "bottom",
        key: "global",
      });
    } catch (error) {
      notification.error({
        message: `Ha ocurrido un error al ${
          approve ? "aprobar" : "desaprobar"
        } el provider, intentelo más tarde.`,
        placement: "bottom",
        key: "global",
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <Switch
      loading={loading}
      disabled={disabled}
      onChange={onChange}
      checked={status !== "banned" && status !== "onboarding"}
    />
  );
};

export default DriverStatusSwitch;
